"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.boxFlexDirection = void 0;
const boxFlexDirection = exports.boxFlexDirection = {
  xs: 'column',
  sm: 'row'
};
